import React, { useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import * as UserActions from "../../../store/actions/User";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import LocalitiesListFields from "../../../constants/DeliveryDrivers/LocalitiesListFields.json";
import variables from "../../../constants/assets/variables";
import { FieldsContainer, Pill } from "../../../constants/assets/containers";
import BlankState from "../../Common/BlankState";
import { capitalizeFirstLetter } from "../../../utils";
import DriverLocalitiesEditState from "./DriverLocalitiesEditState";

const DriverLocalitiesDetails = ({
  driverLocalitiesDetails,
  getDriverLocalitiesDetails,
  editState,
  getCityList,
  getLocalityList,
  cityList,
  localityList,
  updateDriverLocalitiesDetails,
  saveState,
  setSaveState,
  getDriverBasicDetails,
  driverBasicDetails,
  nextPageCity,
  nextPageLocality,
  activeCity,
  activeLocality,
  getCity,
  getLocality,
  setStatus,
}) => {
  const { id } = useParams();

  const getFieldValue = (field, key) => {
    if (key === "active" || key === "freeze_locality") {
      return <Pill isFalse={!field[key]}>{field[key] ? "Yes" : "No"}</Pill>;
    } else return capitalizeFirstLetter(field[key] + "");
  };

  useEffect(() => {
    if (driverLocalitiesDetails.length === 0) {
      getDriverLocalitiesDetails(id);
    }
    if (Object.keys(driverBasicDetails).length === 0) {
      getDriverBasicDetails(id);
    }
  }, []);

  return (
    <DriverLocalitiesDetailsContainer editState={editState}>
      {editState ? (
        <DriverLocalitiesEditState
          updateDriverLocalitiesDetails={updateDriverLocalitiesDetails}
          saveState={saveState}
          setSaveState={setSaveState}
          localityList={localityList}
          cityList={cityList}
          localities={driverLocalitiesDetails}
          driverId={id}
          getCityList={getCityList}
          getLocalityList={getLocalityList}
          nextPageCity={nextPageCity}
          nextPageLocality={nextPageLocality}
          activeCity={activeCity}
          activeLocality={activeLocality}
          getCity={getCity}
          getLocality={getLocality}
          driverBasicDetails={driverBasicDetails}
          getDriverLocalitiesDetails={getDriverLocalitiesDetails}
          setStatus={setStatus}
        />
      ) : (
        <FieldsContainer>
          <FieldHolder repeat={5} display="grid">
            {LocalitiesListFields.map((field, index) => {
              return <span key={index}>{field.name}</span>;
            })}
          </FieldHolder>
          {driverLocalitiesDetails.length > 0 ? (
            driverLocalitiesDetails.map((locality, index) => {
              return (
                <FieldHeading repeat={5} display="grid">
                  {LocalitiesListFields.map((field, idx) => {
                    return (
                      <span key={index + idx}>
                        {getFieldValue(locality, field.key)}
                      </span>
                    );
                  })}
                </FieldHeading>
              );
            })
          ) : (
            <BlankState message=" " />
          )}
        </FieldsContainer>
      )}
    </DriverLocalitiesDetailsContainer>
  );
};

const DriverLocalitiesDetailsContainer = styled(DriverBasicDetailsContainer)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers, City, Locality } = state;
  return {
    driverLocalitiesDetails: DeliveryDrivers.driverLocalities,
    cityList: City.cityList,
    localityList: Locality.localityList,
    driverBasicDetails: DeliveryDrivers.driverBasicDetails,
    nextPageCity: City.nextPageCity,
    nextPageLocality: Locality.nextPageLocality,
    activeCity: City.activeCity,
    activeLocality: Locality.activeLocality,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverLocalitiesDetails: bindActionCreators(
      DeliveryDriversActions.getDriverLocalitiesDetails,
      dispatch
    ),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    updateDriverLocalitiesDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverLocalitiesDetails,
      dispatch
    ),
    getDriverBasicDetails: bindActionCreators(
      DeliveryDriversActions.getDriverBasicDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverLocalitiesDetails);
